import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Paper,
  Typography
} from '@mui/material';

import { EditOutlined } from '@mui/icons-material';

const SummaryCard = ({
  title,
  children,
  onEdit,
  showEdit
}) => (
  <Paper
    sx={{
      mt: 2,
      border: '1px solid #E0E0E0',
      borderRadius: '8px',
      boxShadow: 'none',
      overflow: 'hidden'
    }}
  >
    <Box
      sx={{
        minHeight: 42,
        px: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: '#F5F5F5',
        borderBottom: '1px solid #E0E0E0'
      }}
    >
      <Typography
        sx={{
          color: '#424242',
          fontSize: 13,
          fontWeight: 500
        }}
      >
        {title}
      </Typography>

      {showEdit && (
        <IconButton
          size="small"
          aria-label={`Edit ${title}`}
          onClick={onEdit}
          sx={{
            width: 32,
            height: 32,
            color: '#424242',

            '&:hover': {
              bgcolor: '#FFF8E8'
            }
          }}
        >
          <EditOutlined sx={{ fontSize: 20 }} />
        </IconButton>
      )}
    </Box>

    {children}
  </Paper>
);

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  onEdit: PropTypes.func,
  showEdit: PropTypes.bool
};

SummaryCard.defaultProps = {
  children: null,
  onEdit: () => {},
  showEdit: true
};

export default SummaryCard;